var React = require('react');

function Debugger (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"className":"background","cx":"17","cy":"17","r":"17","fill":"#F5F5F5","key":0}),React.createElement("g",{"fillRule":"nonzero","key":1},[React.createElement("path",{"d":"M25.5 22.162v-.848a.636.636 0 0 0-.637-.637h-8.062a.636.636 0 0 0-.636.637v.848c0 .352.285.637.636.637h8.062a.636.636 0 0 0 .637-.637z","fill":"#9E9E9E","key":0}),React.createElement("path",{"className":"foreground","d":"M15.368 17.308l-5.154 5.154a.636.636 0 0 1-.9 0l-.601-.6a.636.636 0 0 1-.001-.9l4.085-4.104-4.085-4.104a.636.636 0 0 1 .001-.899l.601-.601a.636.636 0 0 1 .9 0l5.154 5.154a.636.636 0 0 1 0 .9z","fill":"#212121","key":1})])]));
}

Debugger.defaultProps = {"width":"34","height":"34"};

module.exports = Debugger;

Debugger.default = Debugger;
